import dayjs from "dayjs";

export const EMPTY_DATE_VALUE = "—";

/**
 * Design-system date copy: "hoy HH:mm" for today, "DD/MM/YYYY HH:mm"
 * otherwise, and the em-dash placeholder for anything unparsable.
 */
export const formatRelativeDateTime = (
  isoDate: string | null | undefined,
  emptyValue: string = EMPTY_DATE_VALUE
): string => {
  if (!isoDate) return emptyValue;
  const date = dayjs(isoDate);
  if (!date.isValid()) return emptyValue;
  return date.isSame(dayjs(), "day")
    ? `hoy ${date.format("HH:mm")}`
    : date.format("DD/MM/YYYY HH:mm");
};
